import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

import useFormValidation from 'hooks/useFormValidation';

import { COUNTRY_LIST, STATE_LIST } from 'constants/address';
import { PO_ADDRESS_VALIDATION_SCHEMA } from 'constants/admin/warehouse';

const POAddressEditForm = ({
  purchaseOrderAddress,
  onSubmit,
  onCancel,
  isLoading,
}) => {
  const initialValues = {
    name: purchaseOrderAddress?.name || '',
    email: purchaseOrderAddress?.email || '',
    phone: purchaseOrderAddress?.phone || '',
    address_line_1: purchaseOrderAddress?.address_line_1 || '',
    address_line_2: purchaseOrderAddress?.address_line_2 || '',
    city: purchaseOrderAddress?.city || '',
    state: purchaseOrderAddress?.state || '',
    country: purchaseOrderAddress?.country || '',
    pincode: purchaseOrderAddress?.pincode || '',
  };

  const { values, errors, touched, handleChange, handleBlur, isValid } =
    useFormValidation(initialValues, PO_ADDRESS_VALIDATION_SCHEMA);

  const handleSubmit = e => {
    e.preventDefault();

    onSubmit(e, values);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Authorised Person <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={values.name}
              onChange={e => handleChange('name', e.target.value)}
              onBlur={() => handleBlur('name')}
              isInvalid={touched.name && errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={values.email}
              onChange={e => handleChange('email', e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={values.phone}
              onChange={e => handleChange('phone', e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Address Line 1</Form.Label>
            <Form.Control
              type="text"
              name="address_line_1"
              value={values.address_line_1}
              onChange={e => handleChange('address_line_1', e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Address Line 2</Form.Label>
            <Form.Control
              type="text"
              name="address_line_2"
              value={values.address_line_2}
              onChange={e => handleChange('address_line_2', e.target.value)}
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              name="city"
              value={values.city}
              onChange={e => handleChange('city', e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>State</Form.Label>
            <Form.Select
              name="state"
              value={values.state}
              onChange={e => handleChange('state', e.target.value)}
            >
              <option value="">Select State...</option>
              {STATE_LIST.map(state => (
                <option key={state.value} value={state.value}>
                  {state.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Country</Form.Label>
            <Form.Select
              name="country"
              value={values.country}
              onChange={e => handleChange('country', e.target.value)}
            >
              <option value="">Select Country...</option>
              {COUNTRY_LIST.map(country => (
                <option key={country.value} value={country.value}>
                  {country.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Pincode</Form.Label>
            <Form.Control
              type="text"
              name="pincode"
              value={values.pincode}
              onChange={e => handleChange('pincode', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="submit"
          variant="success"
          disabled={!isValid || isLoading}
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </Form>
  );
};

export default POAddressEditForm;
